import React from 'react'
import { index, change } from '../../../store/actions/metrics.action'
import { Button, CircularProgress, TextField, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { FcTreeStructure, FcComboChart, FcMoneyTransfer, FcAcceptDatabase, FcBusinessman , FcBarChart, FcFilingCabinet} from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaCalendarAlt, FaShoppingCart, FaUser } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import VerifySms from '../../components/VerifySms'

export default function Metrics(props) {
    const dispatch = useDispatch()
    const action_id = (props.uid) ? props.uid : null;
    const link_id = (props.link_id) ? props.link_id : null;

    const { open, screen_id } = useSelector(state => state.smsReducer)
    const { metric, days } = useSelector(state => state.metricsReducer)

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)
    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(null)
    const [dateFinal, setDateFinal] = React.useState(null)
    const [periodo, setPeriodo] = React.useState('today')
    const [title, setTitle] = React.useState('Hoje')

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        _index(periodo)
    }, [dateInitial, dateFinal])

    React.useEffect(() => {
        const titles = {
            today: 'Hoje',
            week: 'Seg. à Dom',
            month: 'Mês atual',
            geral: 'Todo Período',
            null: 'Personalizado',
            undefined: 'Personalizado'
        }
    
        setTitle(titles[periodo] || 'Personalizado')
    }, [periodo])

    const _index = async (periodo) => {
        setLoad(true)
      
        const initial = dateInitial ? new Date(dateInitial) : null;
        const final = dateFinal ? new Date(dateFinal) : null;
      
        await dispatch(index(action_id, link_id, periodo, initial, final))
      
        setLoad(false)
        setLoading(false)
    }

    const handlePeriodo = (value) => {
        if (periodo !== value) {
            setDateInitial(null)
            setDateFinal(null)
            setPeriodo(value)
            _index(value)
        }
    }

    const getData = (value, index) => {
        if (periodo === 'today' && index === 1) {
            return 'Ontem'
        }
    
        if (periodo !== 'today') {
            if (index === 0) return 'Hoje';
            if (index === 1) return 'Ontem';
        }
    
        return value
    }

    const MetricButton = ({ value, icon }) => (
        <Button
            fullWidth
            className="bs-bg-invert btn-icon-between bs-color-b"
            variant="contained"
            color="primary"
            size="large"
            startIcon={icon}
        >
            {value ? value.toLocaleString('pt-BR', { style: 'decimal' }) : 0}
        </Button>
    )

    return (
        <>
            <VerifySms 
                type="login_code"
                open={screen_id === 'metrics.index' && open}
                onConfirm={() => {
                    _index()
                }}
                onClose={() => window.location.replace('/')}
            />
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => link_id ? dispatch(changeScreenB({ open: false })) : dispatch(changeScreen({ open: false })) } edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            Métricas
                        </Typography>
                    </Toolbar>
                </AppBar>
                
                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                <div className="card p-3 mt-3 mb-2 bs-bg">
                    <h6 className="bs-color-b mb-3">Filtros por Período</h6>

                    <div className="row mb-3">
                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'today' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('today')}
                            >
                                HOJE
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'week' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('week')}
                            >
                                Semana
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'month' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('month')}
                            >
                                Mês
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'geral' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('geral')}
                            >
                                Geral
                            </Button>
                        </div>
                    </div>

                    <div className="row mt-2 mb-3">
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Inicial"
                                    type="datetime-local"
                                    defaultValue={dateInitial}
                                    InputLabelProps={{
                                        shrink: dateInitial ? true : false,
                                    }}
                                    onBlur={e => {
                                        setPeriodo(null)
                                        if(e.target.value) {
                                            setDateInitial(e.target.value)
                                        } else {
                                            setDateInitial(dateInit)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Final"
                                    type="datetime-local"
                                    defaultValue={dateFinal}
                                    InputLabelProps={{
                                        shrink: dateFinal ? true : false,
                                    }}
                                    onBlur={e => {
                                        setPeriodo(null)
                                        if(e.target.value) {
                                            setDateFinal(e.target.value)
                                        } else {
                                            setDateFinal(dateEnd)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                    <>
                        <div className="card p-3 mt-3 mb-2 bs-bg">
                            <label className="fw-bold label-custom bs-color-b">{title}</label>
                            
                            <div className="row mb-4">
                                {metric.total_liquid ?
                                <>
                                    <div className="col-6">
                                        <small className="bs-color mb-1 d-block">Liquido Afiliado</small>
                                        <h1 className="bs-color-b font-size-large mb-0">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.total_liquid)}</h1>
                                    </div>

                                    <div className="col-6 text-end">
                                        <small className="bs-color mb-1 d-block">Total Vendido</small>
                                        <h1 className="bs-color-b font-size-large mb-0">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.total_amount)}</h1>
                                    </div>
                                </>
                                :
                                    <div className="col-6">
                                        <small className="bs-color mb-1 d-block">Liquido</small>
                                        <h1 className="bs-color-b font-size-large mb-0">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.total_amount)}</h1>
                                    </div>
                                }
                            </div>

                            <div className="row mb-2">
                                <div className="col">
                                    <MetricButton value={metric.total_transaction} icon={<FaShoppingCart size={15}/>} />
                                </div>
                                <div className="col">
                                    <MetricButton value={metric.total_user} icon={<FaUser size={15}/>} />
                                </div>
                                <div className="col">
                                    <MetricButton value={metric.total_cotas} icon={<FcTreeStructure size={15}/>} />
                                </div>
                            </div>
                        </div>
                        
                        <div className="card p-3 mt-3 mb-2 bs-bg">
                            <label className="fw-bold label-custom bs-color-b">Últimos 7 Dias</label>
                            
                            {(days.length < 1) &&
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro cadastrado</h6>
                                </div>
                            }
                            
                            {(days.length > 0) &&
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td className="bs-color-b ps-0"><FaCalendarAlt /></td>
                                            <td className="bs-color-b text-center"><FaShoppingCart /></td>
                                            <td className="bs-color-b text-center"><FaUser /></td>
                                            <td className="bs-color-b text-end fw-bold pe-0">Total</td>
                                        </tr>
                                        {days.map((item, index) => {
                                            if (periodo === 'today' && index === 0) return null;
                                                return (
                                                    <tr key={index}>
                                                        <td className="bs-color-b ps-0" scope="row">{getData(item.data_format, index)}</td>
                                                        <td className="bs-color-b text-center">
                                                            {item.total_transaction?.toLocaleString('pt-BR', { style: 'decimal' }) || 0}
                                                        </td>
                                                        <td className="bs-color-b text-center">
                                                            {item.total_user?.toLocaleString('pt-BR', { style: 'decimal' }) || 0}
                                                        </td>
                                                        <td className="bs-color-b text-end pe-0 fw-bold">
                                                            {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.total_amount || 0)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </>
                }
                </>
                }
            </div>
        </>
    )
}